/* eslint-disable no-param-reassign */
import {
  callNativeFunction,
  nativeFunction,
} from '@/utils/detectDevice';

export const isSenior = stage => stage === 'Trial' || stage === 'S2' || stage === 'S3' || stage === 'S4' || stage === 'S5';

const swap = (arr, indexA, indexB) => {
  [arr[indexA], arr[indexB]] = [arr[indexB], arr[indexA]];
};

export const shuffle = (arr) => {
  arr.forEach((_, index) => {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    swap(arr, index, randomIndex);
  });
  return arr;
};

export const convertObject = obj => (
  obj.constructor === Object
    ? obj
    : JSON.parse(obj)
);

export const parseAppVersionToNumber = (versionName = '0.0.0') => parseInt(versionName.split('.').join(''), 10);

export const quitBook = ({ params, push }) => {
  if (window.bookFromHomeWork) { // 自己在window上定义的一个属性
    callNativeFunction(nativeFunction.BACK)(); // 跳到app端，调取back方法
  } else {
    const stageId = params.stageId.replace('-', '/');
    push(`/stage/${params.stage}/${stageId}`); // 图书馆内部跳转
  }
};
